<script>
    import { mapActions, mapState } from "vuex";
    import Swiper from "@/plugins/swiper-bundle";
    import ApplicationFunctionsCard from "@picooc/components/ApplicationFunctionsCard";
    import SliderControls from "@picooc/components/SliderControls";

    export default {
        name: "ApplicationFunctions",
        components: { SliderControls, ApplicationFunctionsCard },
        data() {
            return {
                sliderActiveIndex: 1,
                slider: null,
            };
        },
        computed: {
            ...mapState("Picooc", ["applicationFunctions"]),
        },
        serverPrefetch() {
            return this.getTextCards("app-functions");
        },
        mounted() {
            if (this.applicationFunctions.length === 0) {
                this.getTextCards("app-functions").then(() => {
                    this.initSlider();
                });
            } else {
                this.initSlider();
            }
        },
        methods: {
            ...mapActions("Picooc", ["getTextCards"]),
            initSlider() {
                this.$nextTick(() => {
                    this.slider = new Swiper(".js-application-functions-slider", {
                        spaceBetween: 20,
                        direction: "horizontal",
                        grabCursor: true,
                        lazy: true,
                        navigation: {
                            nextEl: `.js-application-functions-next`,
                            prevEl: `.js-application-functions-prev`,
                        },
                    });

                    this.slider.on("slideChange", (slider) => {
                        this.sliderActiveIndex = slider.activeIndex + 1;
                    });
                });
            },
        },
    };
</script>

<template>
    <section class="application-functions application__section">
        <h2 class="application-functions__title page-title">Больше полезных функций</h2>

        <div v-if="applicationFunctions.length === 0" class="application-functions__loader">
            <preloader :show="true" lg-size></preloader>
        </div>

        <div
            v-if="applicationFunctions.length > 0"
            class="application-functions__list mobile-hidden"
        >
            <div
                class="application-functions__item"
                v-for="func in applicationFunctions"
                :key="func.id"
            >
                <application-functions-card :func="func"></application-functions-card>
            </div>
        </div>

        <div
            v-if="applicationFunctions.length > 0"
            class="application-functions__slider desktop-hidden"
        >
            <div class="swiper-container js-application-functions-slider">
                <div class="swiper-wrapper">
                    <div
                        class="swiper-slide application-functions__slide"
                        v-for="func in applicationFunctions"
                        :key="func.id"
                    >
                        <application-functions-card :func="func"></application-functions-card>
                    </div>
                </div>
            </div>
            <div class="application-functions__counter desktop-hidden">
                <slider-controls
                    :current="sliderActiveIndex"
                    :max="applicationFunctions.length"
                    name="js-application-functions"
                ></slider-controls>
            </div>
        </div>
    </section>
</template>

<style lang="scss">
    .application-functions {
        background-color: #f4fbff;
    }

    .application-functions__title {
        @include bp($bp-desktop-sm) {
            margin-bottom: 34px;
        }
    }

    .application-functions__loader {
        position: relative;
        min-height: 150px;
    }

    .application-functions__list {
        @include bp($bp-desktop-sm) {
            display: flex;
            flex-wrap: wrap;
            margin: 0 -12px -24px;
        }
    }

    .application-functions__item {
        @include bp($bp-desktop-sm) {
            flex-basis: 50%;
            max-width: 50%;
            padding: 0 12px 24px;
        }
        @include bp($bp-desktop-md) {
            flex-basis: 33.333%;
            max-width: 33.333%;
        }
    }

    .application-functions__slider {
        margin: 0 -32px;
        .swiper-container {
            padding: 0 16px;
        }
    }

    .application-functions__slide {
        padding: 24px 16px 24px;
        img {
            margin: 0 auto;
        }
        &.swiper-slide {
            height: auto;
        }
    }

    .application-functions__counter {
        margin-bottom: 16px;
        padding: 0 46px;
    }
</style>
